import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import { DNAChip, DNACustomDeckThumbnail, DNARowsComponent } from 'src/components/DNA';
import { FolderItemORM } from 'src/types/types';
import { isCustomDeckORM } from 'src/types/typeguards';

const styles = StyleSheet.create({
  mainWrapper: {
    backgroundColor: colors['color-gray-500'],
    borderRadius: 4,
    marginVertical: 1,
    paddingLeft: 12,
    paddingRight: 20,
    paddingVertical: 12,
  },
});

const DNADocumentFolderItemCustomDeckVirtualRow: DNARowsComponent<FolderItemORM> = (props) => {
  const {
    ORM: folderItemORM,
    onPress,
    style,
    isOnline,
  } = props;

  if (!isCustomDeckORM(folderItemORM.relations.itemORM)) {
    return <></>;
  }

  const customDeckORM = folderItemORM.relations.itemORM;
  const unavailableContent = !isOnline && !customDeckORM.meta.assets.isContentCached;
  const isReviewRequired = customDeckORM.meta.version.requiresReview;

  return (
    <DNACard
      appearance="flat"
      interactive="pressable"
      onPress={() => !isReviewRequired && onPress?.(folderItemORM)}
      style={[styles.mainWrapper, style]}
    >
      <DNABox alignY="center" spacing="between" childFill={0} style={isReviewRequired && { opacity: 0.4 }}>
        <DNABox spacing="lg" alignY="center" childFill={1}>
          <DNABox style={{ backgroundColor: 'black' }}>
            <DNACustomDeckThumbnail.Hover
              customDeckORM={customDeckORM}
              width={126}
              height={72}
              unavailableContent={unavailableContent}
            />
          </DNABox>
          {/* Title */}
          <DNABox spacing="sm" appearance="col" childFill>
            <DNAText b2 colorMode="dark" numberOfLines={1}>
              {folderItemORM.model.customTitle}
            </DNAText>
            <DNABox alignY="center" spacing="sm">
              <DNAChip.Beacon variant="MODIFIED" />
            </DNABox>
          </DNABox>
        </DNABox>
      </DNABox>
    </DNACard>
  );
};

export default DNADocumentFolderItemCustomDeckVirtualRow;
